import type { CategoryContent } from '../row.js';

export const INORGANIC_CHEMISTRY: CategoryContent = {
  bscba: [
    [
      'Wat is het coördinatiegetal van het metaalcentrum in het complex [Cu(NH3)4]2+?',
      [
        '4',
        '2',
        '3',
        '6',
      ],
      0,
      'Vier ammonialiganden binden direct aan Cu(II), wat een coördinatiegetal van 4 geeft.',
    ],
    [
      'Hoe splitsen de d-orbitaalenergieën in een octaëdrisch metaalcomplex volgens kristalveldentheorie?',
      [
        'De d-orbitalen splitsen in twee energieniveaus',
        'Alle vijf d-orbitalen nemen energie gelijk toe',
        'De d-orbitalen splitsen in s- en p-orbitalen',
        'Alleen de dz2-orbitaal wordt beïnvloed door het ligandenveld',
      ],
      0,
      'Octaëdrische liganden breken d-orbitalgedegeneratie; t2g-orbitalen zijn lager en eg-orbitalen hoger ten opzichte van het zwaartepunt.',
    ],
    [
      'Wat kenmerkt een Lewiszuur-baseinteractie in de coördinatiechemie?',
      [
        'Een elektronenpaardonor bindt aan een acceptor',
        'Overdracht van protonen tussen species',
        'Vorming van ionbindingen tussen neutrale liganden en metaalionen',
        'Breking van sigmaverbindingen in het ligand',
      ],
      0,
      'Lewis-zuur (metaal) accepteert elektronen van Lewis-base (ligand), wat een coördinatiecovalente binding vormt.',
    ],
    [
      'Wat is het primaire verschil tussen octaëdrische en tetraëdrische coördinatiegeometrie?',
      [
        'Octaëdrisch heeft 6 liganden; tetraëdrisch heeft 4',
        'Beide geometrieën hebben altijd hetzelfde coördinatiegetal',
        'Tetraëdrisch is altijd stabieler dan octaëdrisch',
        'Het verschil is alleen in kleur, niet in geometrie',
      ],
      0,
      'Octaëdrisch (CN=6, d-orbitalsplitsing ~1,2 eV) is typisch voor d6–d9-metalen; tetraëdrisch (CN=4, grotere splitsing) is gunstiger voor d0, d5, d10.',
    ],
    [
      'In transitiemetaalchemie, wat ordent de spectrochemische reeks?',
      [
        'Liganden op volgorde van splitsingssterkte',
        'Metalen naar volgorde van oxidatiestaatsstabiliteit',
        'Golflengten van licht geabsorbeerd door complexen',
        'Thermische stabiliteit van coördinatieverbindingen',
      ],
      0,
      'De reeks rangschikt liganden naar Δ-splitsingssterkte: CN− en CO zijn sterkveld; I−, Br− zijn zwakveld.',
    ],
    [
      'Welk type isomerie wordt vertoond door [Co(NH3)5Cl]2+ en [Co(NH3)4(OH)]Cl?',
      [
        'Ionisatie-isomerie',
        'Koppelingsisomerie',
        'Geometrische isomerie',
        'Optische isomerie',
      ],
      0,
      'Ionisatie-isomeren verschillen in welke anionen gecoördineerd zijn versus tegenionen; één heeft Cl− gebonden, de ander als vrije ion.',
    ],
    [
      'In vastestofchemie, wat is een roosterconstante?',
      [
        'Afstand tussen roosterpunten',
        'Het aantal atomen per eenheidscel',
        'De hoek waaronder atomen elkaar afstoten',
        'De trilfrequentie van atomen in evenwicht',
      ],
      0,
      'Roosterconstanten (a, b, c, α, β, γ) bepalen de eenheidscelafmetingen en zijn direct meetbaar door röntgendiffractie.',
    ],
    [
      'Welk type binding is kenmerkend voor organometaalchemie?',
      [
        'Een directe metaal-naar-koolstof covalente binding',
        'Een ionische interactie via hydrideoverspreiding',
        'Een waterstofbinding gemedieerd door een bruggend atoom',
        'Een van der Waals-contact zonder covalent karakter',
      ],
      0,
      'Organometaalbindingen bevatten M–C σ-bindingen (alkyl) en π-bindingen (alkeen, alkijn, karbeen-coördinatie).',
    ],
    [
      'Wat is de primaire rol van een katalysator in een metaalcomplex-gekatalyseerde reactie?',
      [
        'Verlaagt de activeringsenergie zonder zelf verbruikt te worden',
        'Verschuift de evenwichtsconstante om producten te bevoordelen',
        'Verhoogt de enthalpie van de reactie',
        'Levert warmte-energie aan het reactiesysteem',
      ],
      0,
      'Katalysatoren verlagen Ea en worden aan het einde van de cyclus geregenereerd; ze verhogen de reactiesnelheid, maar niet ΔG.',
    ],
    [
      'In zuur-basenchemie, wat onderscheidt een Brønsted-zuur van een Lewis-zuur?',
      [
        'Brønsted-zuren doneren protonen; Lewis-zuren accepteren elektronenparen',
        'Brønsted-zuren zijn altijd sterker dan Lewis-zuren',
        'Brønsted-basen zijn gerelateerd aan Lewis-basen door ionische binding',
        'Lewis-zuren moeten positief geladen zijn; Brønsted-zuren kunnen neutraal zijn',
      ],
      0,
      'Brønsted: H+-donor/-acceptor. Lewis: elektronenpaar-acceptor/-donor. Alle Brønsted-zuren zijn Lewis-zuren, maar niet omgekeerd (bijv. BF3).',
    ],
    [
      'Wat is de primaire ligand van hemoglobine bij reversibele zuurstofbinding?',
      [
        'Het ijzer(II)-centrum in een heemgroep',
        'Histidineresiduen binden direct moleculair zuurstof',
        'Sulfidebruggen coördineren zuurstofmoleculen',
        'Carboxylaatgroepen vormen reversibele O2-addukten',
      ],
      0,
      'Fe(II) in heemporfyrine IX bindt O2 reversibel; myoglobine functioneert vergelijkbaar, maar met een hogere zuurstofaffiniteit.',
    ],
    [
      'In het complex [Fe(CN)6]4−, hoeveel elektronenparen doneert cyanide aan ijzer?',
      [
        '6 elektronenparen',
        '3 elektronenparen',
        '6 ongepaarde elektronen',
        '12 eenzame paren van de liganden',
      ],
      0,
      'CN− doneert 1 σ eenzaam paar (2 elektronen); zes liganden doneren 12 elektronen totaal aan een zeer lage-spins Fe(II)-complex.',
    ],
    [
      'Wat is het typische coördinatiegetal voor een tetraëdrisch complex?',
      [
        '4',
        '6',
        '8',
        '2',
      ],
      0,
      'Tetraëdrische coördinatie plaatst vier liganden op de hoekpunten van een tetraëder rond het centraalmetaal (CN = 4).',
    ],
    [
      'Welke factor bepaalt primair of een transitiemetaalcomplex gekleurd is?',
      [
        'd-orbitalsplitsing maakt overgangen in zichtbaar licht mogelijk',
        'De aanwezigheid van paramagnetische elektronen in het complex',
        'De lading van het complexion',
        'De massa van de ligandatomen',
      ],
      0,
      'Kleur ontstaat uit d–d-overgangen (als Δ binnen het zichtbare bereik valt, 400–700 nm) of uit ladingsoverdrachtabsorpties.',
    ],
    [
      'Wat is het chelaateffect, en waarom vormen chelerende liganden stabielere complexen?',
      [
        'Meertandige liganden binden via meerdere donorsites',
        'Chelerende liganden vormen zwakkere bindingen dan monodentate equivalenten',
        'Chelatie vereist alleen ionische binding',
        'Chelaatvormers bevatten altijd stikstof',
      ],
      0,
      'Chelatie: meerdere donors verminderen het aantal deeltjes in oplossing (gunstige ΔS); elke donor-metaalbinding draagt bij aan binding (cumulatieve ΔH).',
    ],
  ],
  msc: [
    [
      'Waarom veroorzaakt CN− een grotere kristalveldsplitsing (Δ) dan F−, ondanks dat F− kleiner is?',
      [
        'CN− heeft π-terugbinding, F− is zuiver σ',
        'F− is een sterkveldligand omdat het elektronegatief is',
        'Beide liganden veroorzaken identieke d-orbitalsplitsing',
        'CN− en F− kunnen geen octaëdrische complexen vormen',
      ],
      0,
      'Sterkveldliganden (CN−, CO) benutten π-terugbinding; zwakveldliganden (F−) doneren alleen σ. π-interacties vergroten Δ aanzienlijk.',
    ],
    [
      'In ligandveldtheorie, wat is de rol van π-terugbinding in metaalkarbonylbindingen?',
      [
        'Metaal-d-elektronen doneren aan π*-orbitalen van CO',
        'Ligand-elektronen worden onomkeerbaar overgebracht naar metaal d-orbitalen',
        'De metaaloxidatietoestand neemt toe door elektronverlies',
        'π-binding is destructief en verzwakt complexstabiliteit',
      ],
      0,
      'Synergisch effect: M→CO σ + CO←M π versterken elkaar; π-terugbinding verlengt de C≡O-binding en verzwakt die, wat de metaal-ligandbinding sterker maakt.',
    ],
    [
      'Hoe openbaart het Jahn–Teller-effect zich in octaëdrisch Cu(II) d9-complexen?',
      [
        'Axiale verlenging of compressie verwijdert degeneratie',
        'Het complex stoot spontaan één ligand uit om vierkant-piramidaal te worden',
        'Het metaal oxideert naar Cu(III) om een d8-configuratie te bereiken',
        'Alle octaëdrische Cu(II)-complexen zijn perfect symmetrisch',
      ],
      0,
      'Cu(II) d9 heeft één ongepaarde eg-elektron; vervorming heft degeneratie op en stabiliseert het complex (Jahn–Teller stelling).',
    ],
    [
      'Wat is de relatie tussen magnetisch moment en ongepaarde d-elektronen in transitiemetaalcomplexen?',
      [
        'μ = √[n(n+2)] μB, waarbij n het aantal ongepaarde elektronen is',
        'Magnetisch moment wordt alleen bepaald door atoomnummer',
        'Gepaarde elektronen in d-orbitalen heffen alle magnetisme volledig op',
        'Alleen s-elektronen dragen bij aan het totale magnetische moment',
      ],
      0,
      'Spin-only benadering: μ ∝ √[n(n+2)]; orbitaalbijdragen en spin-orbitale koppeling verfijnen dit voor eerste-rij transitiemetalen.',
    ],
    [
      'In de NaCl (steenzout)-structuur, wat is de coördinatiesfeer van elk ion?',
      [
        'Na+ heeft 6 Cl−-buren; Cl− heeft 6 Na+-buren',
        'Elk ion is tetraëdrisch gecoördineerd aan 4 buurionen',
        'Na+ en Cl− vormen afwisselende ketens met CN = 2',
        'De structuur is amorf zonder lange-afstandsorde',
      ],
      0,
      'Steenzout: zowel Na+ als Cl− nemen octaëdrische coördinatie aan (CN = 6) in een afwisselend FCC-rooster. Dit hoge CN verhoogt de elektrostatische stabiliteit.',
    ],
    [
      'Wat is het chelaateffect, en hoe verschilt het van eenvoudige ligandverdringing?',
      [
        'Chelatie biedt extra entropische en enthalpische stabilisatie',
        'Monodentate liganden vormen sterkere bindingen dan chelerende liganden',
        'Chelatie vereist alleen ionische binding',
        'Chelaatvormers moeten alleen stikstofdonoren bevatten',
      ],
      0,
      'Chelaateffect: bidentate liganden verhogen ΔS (minder deeltjes) en bieden cumulatieve ΔH; EDTA bindt metaalionen veel sterker dan NH3.',
    ],
    [
      'Hoe beïnvloedt elektronendichtheid op het metaal de reactiviteit van een organometaalcomplex?',
      [
        'Elektronenrijke metalen zijn nucleofiel; elektronarme zijn elektrofiel',
        'Alle metalen vertonen identieke reactiviteit ongeacht elektronische omgeving',
        'Alleen d10-metalen zijn reactief in organometaalkatalyse',
        'De ligandomgeving heeft geen effect op de metaalreactiviteit',
      ],
      0,
      'De elektronische toestand van het metaal (oxidatiegetal, d-getal, ligandomgeving) bepaalt de elektronendichtheid en reactiviteit: een hoge elektronendichtheid maakt het nucleofiel.',
    ],
    [
      'Wat is het verschil tussen "hoogspin" en "laagspin" configuraties in octaëdrische complexen?',
      [
        'Zwakveld geeft hoogspin; sterkveld geeft laagspin',
        'Hoogspin en laagspin verwijzen naar de kernspintoestand',
        'Hoogspin-complexen zijn altijd tetraëdrisch; laagspin-complexen zijn octaëdrisch',
        'De termen beschrijven ligandsterische omvang, geen elektronische effecten',
      ],
      0,
      'De spintoestand hangt af van de paaringsenergie P ten opzichte van de splitsingsenergie Δ: zwakveld (Δ < P) geeft hoogspin, sterkveld (Δ > P) geeft laagspin.',
    ],
    [
      'In redoxkatalyse, hoe regenereert de elektronoverdrachtketen de katalysator?',
      [
        'Elektronoverdracht regenereert de katalysator elke cyclus',
        'Het metaalcentrum wordt permanent geoxideerd of gereduceerd',
        'Alle elektronen worden tegelijk in één stap overgebracht',
        'Omkeerbaarheid wordt voorkomen om reactie vooruit te drijven',
      ],
      0,
      'Katalytische cyclus: M^n+ + substraat → M^(n±1) + productintermediair → M^n+ geregenereerd; de katalysator keert terug naar zijn oorspronkelijke oxidatietoestand.',
    ],
    [
      'Welke structuurrol spelen histidineresiduen in hemoproteïnen?',
      [
        'Histidine is de vijfde axiale heemligand',
        'Histidine bindt direct zuurstofmoleculen',
        'Histidine is alleen aan de peptiderug gekoppeld',
        'IJzer(III)-hemoproteïnen binden nooit zuurstof',
      ],
      0,
      'In hemoglobine en myoglobine bindt de proximale histidine (imidazol-N) Fe(II) axiaal; de distale histidine helpt bij de O2-stabilisatie.',
    ],
    [
      'Hoe verschilt metaal-naar-ligand ladingsoverdracht (MLCT) van ligand-naar-metaal ladingsoverdracht (LMCT)?',
      [
        'MLCT: metaal naar ligand π*; LMCT: ligand naar metaal d-orbitaal',
        'Beide processen zijn identiek en de termen zijn verwisselbaar',
        'MLCT treedt alleen op in neutrale complexen; LMCT alleen in kationische species',
        'LMCT-absorpties treden altijd op bij hogere energie dan MLCT',
      ],
      0,
      'MLCT is gunstig voor laagvalente, elektronenrijke metalen (Ru(II)); LMCT is gunstig voor hoogvalente, elektronarme metalen (Fe(III)) en anionische liganden (O2−, S2−).',
    ],
    [
      'Wat is de empirische relatie tussen kristalveldsplitsing (Δ) en absorptiegolflengte in d–d overgangen?',
      [
        'Fotonenergie is gelijk aan Δ; grotere Δ geeft kortere golflengten',
        'Δ is onafhankelijk van absorptiegolflengte',
        'Langere golflengten komen altijd overeen met grotere kristalveldsplitsingen',
        'Absorptiegolflengte wordt bepaald door ligandmassa, niet door splitsingsenergie',
      ],
      0,
      'E_foton = hc/λ = Δ; sterkveldcomplexen (grote Δ) absorberen bij λ ~400 nm (blauw); zwakveld (kleine Δ) bij λ ~900 nm (infrarood).',
    ],
    [
      'In cytochroom P450-oxidatiekatalyse, wat is de rol van het ijzercentrum?',
      [
        'IJzer doorloopt oxidatietoestanden naar een oxospecies',
        'IJzer is een structureel raamwerk zonder katalytische rol',
        'IJzer bindt uitsluitend stikstof en kan niet met zuurstof interageren',
        'De eiwitruggengraat voert alle zuurstofactivering uit',
      ],
      0,
      'P450: Fe(II) bindt O2 → vormt Fe(IV)=O (hoogvalent oxo) → hydroxyleert C–H; essentieel voor geneesmiddelmetabolisme en biosynthese.',
    ],
    [
      'Wat is de "18-elektronenregel" in organometaalchemie?',
      [
        'Stabiele complexen hebben vaak 18 valentie-elektronen totaal',
        'Alle metalen moeten onafhankelijk van liganden precies 18 d-elektronen hebben',
        'De regel is alleen van toepassing op hoofd-groepselementen',
        '18 elektronen garanderen complexontbinding',
      ],
      0,
      '18-elektronenregel: d10 + gevulde s/p = gesloten-schaal analoog aan edelgas (Ar/Kr); bevordert kinetische en thermodynamische stabiliteit.',
    ],
    [
      'Hoe relateert het nefelauxetisch effect zich tot de complexkleur van transitiemetalen?',
      [
        'Ligand-elektronen vergroten de d-orbitalen en verlagen zo Δ',
        'Liganden verhogen de effectieve kernlading op de metaalelektronen',
        'Nefelauxetische effecten verschuiven complexkleuren altijd naar blauw',
        'Alleen p-blok elementen ondervinden nefelauxetische effecten',
      ],
      0,
      'Nefelauxetisch effect ("wolkuitbreidend"): ligand-elektronen stoten d-elektronen af, waardoor de d-orbitalen groter worden; de verminderde d–d-afstoting geeft een kleinere Δ en dus een roodverschuiving.',
    ],
  ],
  phd: [
    [
      'In het hoekige overlapmodel (AOM), hoe dragen σ en π-interacties afzonderlijk bij aan d-orbitalenergieën?',
      [
        'σ-donatie en π-afstoting zijn onafhankelijke overlappen',
        'σ en π-interacties hebben identieke effecten op alle d-orbitalen',
        'π-interacties hebben geen effect op d-orbitalenergie',
        'Alle d-orbitalen zijn gelijk gestabiliseerd door zowel σ als π-interacties',
      ],
      0,
      'AOM: σ-binding verhoogt alle d-orbitalen; π-afstoting (loodrechte assen) verhoogt dxy, dxz, dyz. Dit maakt een kwantitatieve voorspelling van Δ mogelijk.',
    ],
    [
      'Wat is het Bailar-draaimechanisme, en wat verklaart het?',
      [
        'Een octaëdrisch ↔ trigonaal-prismatische pseudorotatie',
        'Een eenelektronredoxproces wat ongepaarde-elektronenintermediaten oplevert',
        'Spontane complexontbinding bij hoge temperatuur',
        'Een symmetrische rotatie zonder geometrische veranderingen',
      ],
      0,
      'Bailar-draai: een continue vervorming van octaëdrisch → trigonaal prisma → octaëdrisch verwisselt ligandposities; dit verklaart stereochemische inversie in inerte d3- en d6-complexen.',
    ],
    [
      'Hoe versterken σ-donatie en π-terugbinding in de M–CO-binding elkaar (synergisch effect)?',
      [
        'σ-donatie verhoogt dichtheid, versterkt terugdonatie',
        'π-terugbinding heft σ-donatie-effecten op',
        'σ-donatie en π-terugbinding zijn onafhankelijk',
        'Alleen zwakveld CO vertoont beide σ en π-interacties',
      ],
      0,
      'Synergische cyclus: M→CO σ + CO←M π versterken elkaar; een hogere elektronendichtheid op het metaal versterkt beide, wat de M–CO-binding uitzonderlijk sterk maakt.',
    ],
    [
      'In de Born–Haber-cyclus, wat is de roosterenthalpie en hoe is deze gerelateerd aan de kristalstructuur?',
      [
        'Energie om één mol ionische vaste stof te scheiden',
        'Roosterenthalpie is de smeltenthalpie',
        'Roosterenthalpie is de vervluchtigingsenthalpie van één element',
        'Roosterenthalpie voorspelt alleen de kleur van de verbinding',
      ],
      0,
      'ΔHₗₐₜₜ ∝ (ladingen)/(inter-ionische afstand) en volgt de Born-Landé-vergelijking; grotere ladingen en kleinere ionen verhogen ΔHₗₐₜₜ.',
    ],
    [
      'Welke rol speelt spin-orbitale koppeling (SOC) in elektronische structuur en spectroscopie van zware transitiemetalen?',
      [
        'SOC mengt spin- en orbitaalmomentum',
        'SOC is verwaarloosbaar voor alle eerste-rij transitiemetalen',
        'SOC maakt singlettoestanden volledig onmogelijk in ontspannen moleculen',
        'Alleen zware metalen ondervinden SOC-effecten',
      ],
      0,
      'SOC ∝ Z^4 en is cruciaal voor 4d/5d-metalen; het maakt zwakke d–d-overgangen toegestaan (een toename van de oscillatorsterkte), wat de absorptie-intensiteit verhoogt.',
    ],
    [
      'Wat is de rol van het P-cluster in nitrogenase, en hoe bevordert zijn redoxtoestand N2-reductie?',
      [
        'Het P-cluster shuttlet elektronen naar de FeMo-cofactor',
        'Het P-cluster heeft een vaste oxidatietoestand en neemt niet deel aan elektronenoverdracht',
        'Het P-cluster slaat sulfide op voor N2-binding',
        'P-clusters zijn evolutionaire overblijfselen zonder functie',
      ],
      0,
      'Het P-cluster van nitrogenase doorloopt verschillende oxidatietoestanden en dient als primaire brug voor elektronenoverdracht; de redoxpotentiaal ervan wordt door het eiwit afgestemd.',
    ],
    [
      'Wat is het kwantitatieve verschil in pakefficiëntie tussen FCC en BCC-structuren?',
      [
        'FCC pakt ~74% (CN 12); BCC pakt ~68% (CN 8)',
        'BCC en FCC hebben identieke pakking-efficiëntie',
        'BCC is altijd dichter dan FCC',
        'Pakfractie is onafhankelijk van kristalgeometrie',
      ],
      0,
      'Dichtgepakte structuren (FCC, HCP): 74% pakking, CN = 12; BCC: 68% pakking, CN = 8. Pakkingsefficiëntie is een fundamentele structuurbeschrijver.',
    ],
    [
      'In heterogene katalyse, wat zijn ensembleeffecten en hoe controleren zij oppervlaktereactiviteit?',
      [
        'Reactiviteit hangt af van atoomgeometrie en toestand',
        'Alle metaaloppervlakken zijn chemisch equivalent',
        'Heterogene katalyse hangt alleen af van bulkmetaaleigenschappen',
        'Oppervlaktestructuur heeft geen invloed op reactiemechanisme',
      ],
      0,
      'Ensembleeffecten: het substraat bindt aan meerdere metaalatomen in een specifieke rangschikking; veranderingen in plaatsdichtheid of roostervervorming wijzigen Ea en TOF.',
    ],
    [
      'Wat is de D4h puntgroep, en welke metaalcomplexen adopteren deze geometrie?',
      [
        'Vierkant-planaire geometrie: Pt(II), Au(III), Ni(II)-complexen',
        'Alleen tetraëdrische complexen; D4h kan geen planaire structuren beschrijven',
        'D4h is exclusief voor octaëdrische geometrieën',
        'D4h is geen geldige puntgroep voor transitiemetaalcomplexen',
      ],
      0,
      'Vierkant-planaire D4h: 4 liganden in het vlak, het metaal in het centrum. Voorbeelden: [PtCl4]2−, [AuCl4]−, cisplatine. Vaak d8-metalen.',
    ],
    [
      'In bindingsmodellen van transitiemetaalkarbonylen, verklaar het verschil tussen synergische binding en niet-bindende elektronenafstoting.',
      [
        'Synergische binding versterkt M–CO; niet-bindend is toevallige afstoting',
        'Synergische binding en niet-bindend overlap zijn hetzelfde concept',
        'Niet-bindend overlap is vereist voor M–CO bindingen; synergische binding is zeldzaam',
        'Alleen CO vertoont synergische binding; andere liganden niet',
      ],
      0,
      'Het synergisch effect vergroot de M–CO-binding via terugkoppeling; niet-bindende e−–e−-afstoting is een aparte destabiliserende factor. De synergie domineert.',
    ],
    [
      'Wat is oxidatietoestandambiguïteit in transitiemetaalcomplexen met redox-actieve liganden?',
      [
        'Redox-actieve liganden maken formele oxidatietoestandtoewijzing ambigueus',
        'Oxidatietoestanden zijn altijd ondubbelzinnig toegewezen voor alle complexen',
        'Redox-actieve liganden zijn denkbeeldig en bestaan niet',
        'Alleen metalen, nooit liganden, nemen deel aan redoxchemie',
      ],
      0,
      'Redox-actieve liganden (bipy, phen, semikinon): π-accepterende of radicaalachtige species die van oxidatietoestand kunnen wisselen; de werkelijke valentietoestandtoewijzing is daardoor ambigu.',
    ],
    [
      'In perovskietstructuren (ABX3), wat voorspelt de Goldschmidt-tolerantiefactor?',
      [
        't = (rₐ+rₓ)/[√2(r_B+rₓ)]; t ≈ 1 is kubisch',
        'De tolerantiefactor is irrelevant voor perovskietstabiliteit',
        't is altijd 1 voor alle perovskieten',
        'De tolerantiefactor voorspelt alleen kleur',
      ],
      0,
      'Tolerantiefactor: bij t ≈ 1 is het perovskiet kubisch; bij t < 1 treden kanteling en octaëdrische rotatie op. De factor balanceert de kation-anionradiusverhouding geometrisch.',
    ],
    [
      'Wat is de Tolman-elektronische parameter (TEP) en hoe wordt het gebruikt in ligandkarakterisering?',
      [
        'TEP is de CO-strekfrequentie van [Ni(L)(CO)3]',
        'TEP meet alleen de sterische omvang van de ligand',
        'TEP is alleen voor stikstofdonorliganden gedefinieerd',
        'Hogere ν_CO waarden geven altijd sterkere donoren aan',
      ],
      0,
      'De Tolman-parameter (cm−1): elektronenrijke liganden doneren aan Ni, wat ν_CO verlaagt; elektronarme liganden (π-acceptoren) trekken elektronen weg en verhogen ν_CO. Dit levert een kwantitatieve rangschikking van donoren op.',
    ],
    [
      'Hoe beïnvloeden vervormingen van octaëdrische symmetrie het d-orbitaldiagram?',
      [
        'Verlaagde symmetrie splitst d-orbitalen verder',
        'Vervormingen hebben geen effect op d-orbitalenergieën',
        'Alle vervormingen verhogen alle d-orbitalen gelijk',
        'Vervormingen verhogen octaëdrische symmetrie',
      ],
      0,
      'Symmetrievermindering (D4h, C3v, enz.) heft de d-orbitaaldegeneratie op; asafhankelijke orbitalen splitsen. Dit elektronische effect ligt aan de basis van Jahn-Teller-vervormingen.',
    ],
    [
      'In heterometaalclusters, wat is het voordeel van gemengdmetaalsites ten opzichte van homometaalclusters?',
      [
        'Verschillende metalen activeren verschillende substraten op nabijgelegen sites',
        'Alle metalen in een cluster gedragen zich altijd identiek',
        'Gemengdmetaalclusters zijn altijd minder stabiel dan enkelelementclusters',
        'Verschillende metalen concurreren voor dezelfde site en verminderen totale activiteit',
      ],
      0,
      'Heterometaalclusters: verschillende metalen stemmen onderling de redoxpotentialen af, activeren substraten en maken coöperatieve mechanismen mogelijk (bijvoorbeeld de Fe–Co–S-nitrogenasenabootser).',
    ],
  ],
  professor: [
    [
      'Hoe verbetert de ligandveld-dichtheidsfunctionaaltheorie (LF-DFT) de kristalveldentheorie?',
      [
        'LF-DFT voegt kwantumuitwisseling toe',
        'LF-DFT is gewoon een hernoeming van de kristalveldentheorie',
        'LF-DFT voorspelt alleen geometrie',
        'LF-DFT is vervangen',
      ],
      0,
      'LF-DFT: DFT met alle elektronen, of met ingebedde clusters, gecombineerd met ligandveldanalyse; het legt de uitwisseling, correlatie en covalente menging vast die de kristalveldentheorie (CFT) niet meeneemt.',
    ],
    [
      'Wat is de spectroscopische oorsprong van de gele kleur in [Fe(H2O)6]3+, en waarom domineert LMCT absorptie?',
      [
        'Intense LMCT overschaduwt zwakke d–d overgangen',
        '[Fe(H2O)6]3+ is kleurloos',
        'Water is een sterkveldligand dat laagspin-Fe(III) oplevert',
        'Alle ijzer-aquacomplexen hebben identieke spectra',
      ],
      0,
      '[Fe(H2O)6]3+ vertoont zwakke d–d-overgangen (bleekgeel); een intense LMCT-band (~400 nm) domineert omdat Fe(III) gemakkelijk H2O oxideert (zie het Pourbaix-diagram).',
    ],
    [
      'Hoe bevordert spin-orbitale koppeling intersysteemkruising en niet-stralingsverval in de fotodynamica van metaalcomplexen?',
      [
        'SOC verlaagt de ISC-barrière door toestandsmenging',
        'Spin-orbitale koppeling voorkomt elk verval van de aangeslagen toestand',
        'SOC is irrelevant voor de fotofysica van metaalcomplexen',
        'Alleen organische kleurstofmoleculen ondergaan intersysteemkruising',
      ],
      0,
      'SOC (sterk in 4d/5d) mengt de S1- en T1-golffuncties; het verlaagt de ISC-barrière, bevordert de S1 → T1-overgang en maakt zo langlevende fosforescentie mogelijk.',
    ],
    [
      'Welk DFT-gebaseerd raamwerk verklaart de substraatselectiviteit van nitrogenase (N2 versus N2H+-reductie)?',
      [
        'Redoxafhankelijke activering en clustercoöperatie',
        'Nitrogenase selecteert willekeurig',
        'Sterische uitsluiting alleen verklaart de selectiviteit',
        'Kwantumtunneling is het enige mechanisme',
      ],
      0,
      'Selectiviteit van nitrogenase: DFT toont dat hydride-intermediairen N2H+-vorming bevorderen bij specifieke redoxtoestanden; de geometrie van de site en de elektronenoverdrachtspaden in het cluster dwingen deze discriminatie af.',
    ],
    [
      'Wat is de p–d-uitwisselingsinteractie in transitiemetaaloxiden, en hoe beheerst deze de elektronische eigenschappen?',
      [
        'Menging van d-banden met p-banden',
        'p–d-uitwisseling is verwaarloosbaar in alle oxiden',
        'Alleen de d-band draagt bij; p-banden zijn inert',
        'p–d-uitwisseling verhoogt altijd de geleiding',
      ],
      0,
      'p-d-menging: p-elektronen van het ligand koppelen aan de d-spins van het metaal, wat de ladingsoverdrachtskloof verkleint en cruciaal is voor de grens tussen Mott-isolator en geleider.',
    ],
    [
      'Hoe behandelt de Marcus–Hush-elektronoverdrachttheorie de reorganisatie-energie in de redoxkatalyse van metaalcomplexen?',
      [
        'λᵢₙₙₑᵣ (trillingen) + λₒᵤₜₑᵣ (oplosmiddel)',
        'De Marcus-theorie is achterhaald',
        'Reorganisatie-energie hangt alleen af van temperatuur',
        'Alle redoxreacties hebben identieke λ',
      ],
      0,
      'De Marcus-theorie: λᵢₙₙₑᵣ (geometrieverandering) + λₒᵤₜₑᵣ (herschikking van het oplosmiddel); een hoge λ verschuift het minimum van de reactiecoördinaat en verhoogt zowel Ea als de overpotentiaal.',
    ],
    [
      'Wat onderscheidt binnensfeer- van buitensfeer-elektronoverdrachtmechanismen die door transitiemetaalcomplexen worden gekatalyseerd?',
      [
        'Binnensfeer gebruikt een brug; buitensfeer niet',
        'Binnensfeer- en buitensfeermechanismen zijn identiek',
        'Alleen buitensfeermechanismen treden op in biologische systemen',
        'Binnensfeermechanismen vereisen altijd een volledig gevulde d-schil',
      ],
      0,
      'Binnensfeer: de snelheid ∝ brugstabiliteit (OH−-brugvorming tussen Fe(II) en Fe(III)); buitensfeer: de snelheid ∝ overlap op afstand (hexa-ammine-redoxpartners).',
    ],
    [
      'In homogene katalyse, wat is het katalytische omzetnummer (TON) en welke factoren beperken het?',
      [
        'TON is een omzettingsverhouding, beperkt door deactivering van de katalysator',
        'TON is de snelheid van één katalytische cyclus',
        'TON is onafhankelijk van katalysatorstructuur',
        'Alle homogene katalysatoren bereiken oneindige TON',
      ],
      0,
      'TON kwantificeert de robuustheid van de katalysator; een hoge TON vereist kinetische stabiliteit tegen deactivering door liganddissociatie, redoxzijreacties of precipitatie.',
    ],
    [
      'Welke elektronische toestanden maken in Type I blauwe kopercentra een snelle elektronoverdrachtscyclus in enzymen mogelijk?',
      [
        'Vervormde Cu(II) d9 geeft een snelle cyclus',
        'Blauwe kopercentra zijn altijd Cu(I) d10',
        'Blauwe kopercentra hebben geen rol bij elektronoverdracht',
        'Blauwe kleur wijst op kopervergiftiging',
      ],
      0,
      'Type I Cu(II): d9-configuratie, intense LMCT (600 nm); geometrisch geoptimaliseerd voor snelle ET tussen redoxpartners; gevonden in azurine en plastocyanine.',
    ],
    [
      'Waarom heeft [Fe(H2O)6]2+ zwakke d–d overgangen terwijl FeS-clusters intense Fe–S ladingsoverdracht-absorptie vertonen?',
      [
        'FeS-clusters tonen sterke Fe–S ladingsoverdracht',
        '[Fe(H2O)6]2+ is altijd blauw',
        'Alle ijzercomplexen vertonen identieke CT-overgangen',
        'Ladingsoverdracht is irrelevant voor ijzerbiochemie',
      ],
      0,
      '[Fe(H2O)6]2+ (d6, bleek groen) toont zwakke d–d (Δ ~10.000 cm−1); FeS-clusters (nitrogenase, ferredoxine) tonen intense Fe–S MLCT door hoge covalentie.',
    ],
    [
      'Hoe beïnvloedt de elektronische aard van aangeslagen toestanden (MC, MLCT, LMCT) de fotokatalytische prestaties in kleurstofgesensibiliseerde zonnecellen?',
      [
        'Langlevende MLCT-toestanden bevorderen elektroninjectie in TiO2',
        'Alle aangeslagen toestanden zijn even nuttig voor fotokatalyse',
        'De aard van de aangeslagen toestand is irrelevant voor de fotokatalyse-efficiëntie',
        'Alleen LMCT-toestanden zijn nuttig',
      ],
      0,
      'DSSC: de MLCT-aangeslagen toestand van Ru(bpy)3 is langlevend (τ ~1 μs) en goed afgestemd op elektroninjectie in de geleidingsband van TiO2 (gunstige E_inj).',
    ],
    [
      'Wat onthult het Creutz–Taube-complex [(NH3)5Ru–pyrazine–Ru(NH3)5]5+ over valentiedelokalisatie?',
      [
        'Toont klasse-III-delokalisatie via het pyrazine',
        'Valentiedelokalisatie treedt nooit op',
        'Het Creutz–Taube-complex heeft altijd een vastgestelde valentie',
        'Bruggliganden voorkomen elektronoverdracht',
      ],
      0,
      'Creutz–Taube: klasse-III gemengde valentie (gedelokaliseerd); IR- en magnetische gegevens tonen een gemiddelde Ru(II.5)-valentie; het π-systeem van pyrazine maakt snelle intermetallische elektronenoverdracht mogelijk.',
    ],
    [
      'Hoe verfijnen continuum-oplosmiddelmodellen (PCM, COSMO) DFT-voorspellingen van de redoxpotentialen van metaalcomplexen?',
      [
        'Modelleert screening van Coulomb-effecten',
        'Oplosmiddelmodellen hebben geen effect op redoxpotentiaalvoorspellingen',
        'Redoxpotentialen hangen alleen af van de oxidatietoestand',
        'Alleen expliciete watermoleculen zijn relevant',
      ],
      0,
      'Continuum-oplosmiddelmodel (PCM): het schermt Coulomb-effecten op lange afstand af voor geoxideerde/gereduceerde toestanden; dit verfijnt de berekende E°-voorspellingen tot binnen 0,1–0,2 V.',
    ],
    [
      'Wat is de rol van hemilabiele liganden in katalyse, en hoe verschillen zij van statische chelerende liganden?',
      [
        'Één donor-arm dissocieert reversibel en opent een substraatsite',
        'Hemilabiele liganden zijn permanent vastgehecht',
        'Statische en hemilabiele liganden hebben identieke katalytische eigenschappen',
        'Hemilabiele liganden verschijnen alleen in stoichiometrische reacties',
      ],
      0,
      'Hemilabiel ontwerp: een lage dissociatie-energie van één arm balanceert de toegankelijkheid voor het substraat (een open coördinatieplaats) met stabiliteit (de andere arm blijft gebonden); dit verbetert de TON/TOF.',
    ],
    [
      'Wat is de computationele uitdaging bij het voorspellen van de spinovergangstemperatuur (SCO) voor ijzer(II)-complexen?',
      [
        'Nauwkeurige ΔS_vib en elektronische entropie zijn nodig omdat ΔG klein is',
        'SCO-temperaturen zijn experimenteel vast en variëren nooit',
        'Alleen de enthalpie van de overgang is belangrijk; entropie is irrelevant',
        'Computationele methoden overschatten SCO-temperaturen altijd met ordes van grootte',
      ],
      0,
      'SCO: een DFT-voorspelde T_SCO vereist nauwkeurige waarden voor ΔH en ΔS (trillingen, elektronisch); de smalle ΔG-marge (~1 kJ/mol) vereist hoge nauwkeurigheid.',
    ],
  ],
};
